/**
 * PL/SQL Debugger Feature Module
 *
 * Registers the pl-sql-debugger workspace type and exports public APIs.
 */

import { registerWorkspaceComponent } from '../core/registry/workspaceRegistry';
import { lazyWorkspaceTab } from '../core/registry/lazyWorkspaceTab';

// Register the pl-sql-debugger workspace component
registerWorkspaceComponent(
  'pl-sql-debugger',
  lazyWorkspaceTab(() => import('./components/PlSqlDebuggerTab').then((m) => ({ default: m.PlSqlDebuggerTab }))),
);

// Re-export components and helpers
export { findExistingDebuggerTab, findExistingEditorTab } from './hooks/debugHelpers';
